// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#ProductSectionFour {
  background: rgba(231, 176, 81, 0.1490196078);
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
  padding: 110px 180px;
}

.ProductSectionFour-left {
  display: flex;
  width: 50%;
  flex-direction: column;
}

#ProductSectionFour-left-head {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 43px;
  line-height: 50px;
  color: #ec6927;
  margin-bottom: 30px;
}

#ProductSectionFour-left-middle {
  display: flex;
  flex-direction: row;
}

#ProductSectionFour-left-middle-left {
  text-align: left;
  padding-right: 3%;
  border-right: unset !important;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  color: #1c2640;
  padding-right: 100px;
}
#ProductSectionFour-left-middle-left ul.list-delivers {
  margin: 0;
  list-style-type: none;
}
#ProductSectionFour-left-middle-left ul.list-delivers li {
  margin-top: 20px;
  display: flex;
}
#ProductSectionFour-left-middle-left ul.list-delivers li .check-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: 7.5px;
}

#ProductSectionFour-discovermore {
  color: #ec6927;
  margin-top: 2%;
  cursor: pointer;
}

#ProductSectionFour-left-middle-right {
  text-align: left;
  margin-left: 5%;
}

#ProductSectionFour-left-middle-bottom {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 5%;
}

#ProductSectionFour-schedule-a-demo {
  width: 130px;
  height: 33px;
  background: #ec6927;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: nFour;
  color: white;
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  cursor: pointer;
}

#ProductSectionFour-explore-how {
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  width: 25%;
  line-height: 16px;
}

.ProductSectionFour-right {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#ProductSectionFour-page1-banner {
  width: 100%;
}

#ProductSectionFour-page1-video {
  position: absolute;
  margin-top: 50px;
}

.subtitle-video {
  font-weight: bold;
  margin-top: -50px;
}

#ProductSectionFour-spinner-bg {
  width: 90%;
  height: auto;
  margin-top: 40px;
  margin-right: -70px;
}

.ProductSectionFour-percentage {
  padding: 30px;
  display: flex;
  justify-content: center;
}

span.ProductSectionFour-number {
  font-size: 42px;
  font-weight: bolder;
  color: #ea6927;
  margin-right: 20px;
}

span.ProductSectionFour-subtilte-number {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 29px;
  color: #ec6927;
  width: 60%;
  margin-top: 5px;
}

.ProductSectionFour-term {
  display: grid;
  line-height: normal;
  margin-left: 30%;
}

span.ProductSectionFour-term-value {
  font-size: 40px;
  font-weight: bolder;
  color: #1c2640;
}

span.ProductSectionFour-term-info {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 42px;
  color: #1c2640;
}

ul {
  line-height: 1.86;
}`, "",{"version":3,"sources":["webpack://./src/components/Product/SectionFour/sectionFour.scss"],"names":[],"mappings":"AAAA;EAEC,4CAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAAD;;AAGA;EACC,aAAA;EACA,UAAA;EACA,sBAAA;AAAD;;AAOA;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAJD;;AAOA;EACC,aAAA;EACA,mBAAA;AAJD;;AAOA;EACC,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;AAJD;AAMC;EACC,SAAA;EACA,qBAAA;AAJF;AAKE;EACC,gBAAA;EACA,aAAA;AAHH;AAKG;EACC,WAAA;EACG,YAAA;EACA,kBAAA;EACA,iBAAA;AAHP;;AASA;EACC,cAAA;EACA,cAAA;EACA,eAAA;AAND;;AAQA;EACC,gBAAA;EACA,eAAA;AALD;;AAQA;EACC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;AALD;;AAQA;EACC,YAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AALD;;AAQA;EACC,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;AALD;;AAQA;EACC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AALD;;AAQA;EACC,WAAA;AALD;;AAQA;EACC,kBAAA;EACA,gBAAA;AALD;;AAQA;EACC,iBAAA;EACA,iBAAA;AALD;;AAQA;EACC,UAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AALD;;AAOA;EACC,aAAA;EACA,aAAA;EACA,uBAAA;AAJD;;AAMA;EACC,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAHD;;AAMA;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;AAHD;;AAMA;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;AAHD;;AAMA;EACC,eAAA;EACA,mBAAA;EACA,cAAA;AAHD;;AAMA;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;AAJD;;AAOA;EACC,iBAAA;AAJD","sourcesContent":["#ProductSectionFour {\n\t// min-height: 80vh;\n\tbackground: #e7b05126;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tposition: relative;\n\tpadding: 110px 180px;\n}\n\n.ProductSectionFour-left {\n\tdisplay: flex;\n\twidth: 50%;\n\tflex-direction: column;\n\t// align-items: center;\n\t// justify-content: center;\n\t// gap: 6%;\n\t// padding-left: 85px;\n}\n\n#ProductSectionFour-left-head {\n\tfont-family: Roboto;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tfont-size: 43px;\n\tline-height: 50px;\n\tcolor: #ec6927;\n\tmargin-bottom: 30px;\n}\n\n#ProductSectionFour-left-middle {\n\tdisplay: flex;\n\tflex-direction: row;\n}\n\n#ProductSectionFour-left-middle-left {\n\ttext-align: left;\n\tpadding-right: 3%;\n\tborder-right: unset !important;\n\tfont-family: Roboto;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-size: 18px;\n\tline-height: 26px;\n\tcolor: #1c2640;\n\tpadding-right: 100px;\n\n\tul.list-delivers{\n\t\tmargin: 0;\n\t\tlist-style-type: none;\n\t\tli{\n\t\t\tmargin-top: 20px;\n\t\t\tdisplay: flex;\n\t\t\t\n\t\t\t.check-icon{\n\t\t\t\twidth: 20px;\n\t\t\t    height: 20px;\n\t\t\t    margin-right: 10px;\n\t\t\t    margin-top: 7.5px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n#ProductSectionFour-discovermore {\n\tcolor: #ec6927;\n\tmargin-top: 2%;\n\tcursor: pointer;\n}\n#ProductSectionFour-left-middle-right {\n\ttext-align: left;\n\tmargin-left: 5%;\n}\n\n#ProductSectionFour-left-middle-bottom {\n\twidth: 80%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: flex-start;\n\tgap: 5%;\n}\n\n#ProductSectionFour-schedule-a-demo {\n\twidth: 130px;\n\theight: 33px;\n\tbackground: #ec6927;\n\tbox-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n\tborder-radius: 3px;\n\tborder: nFour;\n\tcolor: white;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-size: 13.5px;\n\tcursor: pointer;\n}\n\n#ProductSectionFour-explore-how {\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-size: 13.5px;\n\twidth: 25%;\n\tline-height: 16px;\n}\n\n.ProductSectionFour-right {\n\twidth: 50%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n#ProductSectionFour-page1-banner {\n\twidth: 100%;\n}\n\n#ProductSectionFour-page1-video {\n\tposition: absolute;\n\tmargin-top: 50px;\n}\n\n.subtitle-video {\n\tfont-weight: bold;\n\tmargin-top: -50px;\n}\n\n#ProductSectionFour-spinner-bg {\n\twidth: 90%;\n\theight: auto;\n\tmargin-top: 40px;\n\tmargin-right: -70px;\n}\n.ProductSectionFour-percentage {\n\tpadding: 30px;\n\tdisplay: flex;\n\tjustify-content: center;\n}\nspan.ProductSectionFour-number {\n\tfont-size: 42px;\n\tfont-weight: bolder;\n\tcolor: #ea6927;\n\tmargin-right: 20px;\n}\n\nspan.ProductSectionFour-subtilte-number {\n\tfont-family: Roboto;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tfont-size: 25px;\n\tline-height: 29px;\n\tcolor: #ec6927;\n\twidth: 60%;\n\tmargin-top: 5px;\n}\n\n.ProductSectionFour-term {\n\tdisplay: grid;\n\tline-height: normal;\n\tmargin-left: 30%;\n}\n\nspan.ProductSectionFour-term-value {\n\tfont-size: 40px;\n\tfont-weight: bolder;\n\tcolor: #1c2640;\n}\n\nspan.ProductSectionFour-term-info {\n\tfont-family: Roboto;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tfont-size: 36px;\n\tline-height: 42px;\n\n\tcolor: #1c2640;\n}\n\nul {\n\tline-height: 1.86;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
